/* global jQuery */
/**
* File email-signup.js
*
* Handle email signups.
*/
window.emailSignup = {};
( function( window, $, app ) {

	/**
	 * Initialize our functionality.
	 *
	 * @since April 22, 2021
	 */
	app.init = function() {
		app.cache();

		if ( app.meetsRequirements() ) {
			app.bindEvents();
		}
	};

	/**
	 * Cache our variables.
	 *
	 * @since April 22, 2021
	 */
	app.cache = function() {
		app.$c = {
			window: $( window ),
			emailSignupForm: $( '#es-form' ),
			newsletterCheckbox: $( '#checkbox-newsletter-optin' ),
			postalCodeInput: $( '#postal-code' ),
			formClose: $( '.es-form-response-close' )
		};
	};

	/**
	 * Bind events.
	 *
	 * @since April 22, 2021
	 */
	app.bindEvents = function() {
		app.$c.emailSignupForm.on( 'submit', app.submitForm );
		app.$c.newsletterCheckbox.on( 'click', app.toggleCheckboxValue );
		app.$c.postalCodeInput.on( 'keyup', app.formatPostalCode );
		app.$c.formClose.on( 'click', app.closeModal );
	};

	/**
	 * Correctly format the postal code while the user is typing
	 *
	 * @since April 22, 2021
	 *
	 */
	app.formatPostalCode = function() {
		$( this ).val( $( this ).val().toUpperCase() );
	};

	/**
	 * Trigger closing the error modal window with the keyboard.
	 *
	 * @since May 3, 2021
	 *
	 */
	app.escCloseModal = function( e ) {
		// Handle an ESC close via the keyboard
		if ( 27 === e.keyCode ) {
			// Remove the handler class trigger.
			$( '.es-form-response-wrapper' ).removeClass( 'open' );

			// Remove the event handler.
			$( window ).off( 'keyup' );

			// Close the modal.
			app.closeModal();
		}
	};

	/**
	 * Close the error modal window to allow resubmission of the form
	 *
	 * @since May 3, 2021
	 *
	 */
	app.closeModal = function() {
		// Hide the response.
		$( '.es-form-response-wrapper' ).hide();
		$( '.content-wrap.response' ).hide();
		$( '.es-form-response-error .notice-title, .es-form-response-error .notice-1, .es-form-response-error .notice-2, .es-form-response-error .notice-3, .es-form-response-error .notice-default' ).addClass( 'hidden' );

		// Re-enable another submission.
		$( '.es-form-submit' ).attr( 'disabled', false );
	};

	/**
	 * Toggle the checkbox value
	 *
	 * @since April 22, 2021
	 *
	 */
	app.toggleCheckboxValue = function() {
		$( this ).attr( 'checked', this.checked ? true : false );
	};

	/**
	 * Submit emailSignupForm
	 *
	 * @since April 22, 2021
	 * @param {Object} event The event.
	 *
	 */
	app.submitForm = function( event ) {
		event.preventDefault();
		// Don't submit the form if no newsletter is checked
		if ( $( '#es-form .checkbox-group.required :checkbox:checked' ).length > 0 ) {
			$( '.checkbox-group .es-form-unchecked' ).addClass( 'hidden' );

			const postUrl = window.frontendi18n.subscribeRoute;
			const requestMethod = 'post';
			const formData = app.createFormDataObject( $( this ) );

			app.ajaxRequest( formData, postUrl, requestMethod );
		} else {
			$( '.checkbox-group .es-form-unchecked' ).removeClass( 'hidden' );
		}
	};

	/**
	 * Send the AJAX Request for the form
	 *
	 * @since April 22, 2021
	 * @param {Array} formData The form data.
	 * @param {string} postUrl The endpoint URL.
	 * @param {string} requestMethod The type of request.
	 *
	 */
	app.ajaxRequest = function( formData, postUrl, requestMethod ) {

		// Google Recaptcha
		window.grecaptcha.ready( function() {

			window.grecaptcha.execute( window.recaptchaV3.siteKey, { action: 'submit' } ).then( function( token ) {

				// Strip out empty properties.
				Object.keys( formData ).forEach( ( key ) => ( '' === formData[ key ] ) && delete formData[ key ] );

				formData.token = token;

				$.ajax( {
					url: postUrl,
					type: requestMethod,
					contentType: 'application/json',
					data: JSON.stringify( formData ),
					dataType: 'json',

					/**
					 * Before the AJAX request goes through, do this...
					 *
					 * @since November 19, 2020
					 */
					beforeSend() {

						// Disable further submission.
						$( '.es-form-submit' ).attr( 'disabled', true );

						// Show the loading spinner.
						$( '.es-form-response-wrapper' ).css( 'display', 'flex' );
						$( '.content-wrap.loading' ).css( 'display', 'flex' );

					},
				} ).done( function( response ) {

					app.$c.emailSignupForm.hide();

					let responseString = 1 === response.data.length ? response.data[0] : `${response.data[0]}, ${response.data[1]}`;

					$( '.newsletter-name' ).html( responseString );
					$( '.es-form-response-success' ).removeClass( 'hidden' );

				} ).fail( function( error ) {

					// Hide the loading spinner.
					$( '.content-wrap.loading' ).hide();

					// Show the response.
					$( '.es-form-response-wrapper' ).css( 'display', 'flex' );
					$( '.es-form-response-wrapper' ).addClass( 'open' );
					$( '.content-wrap.response' ).css( 'display', 'flex' );

					// Add handler to close the modal with the keyboard.
					$( window ).on( 'keyup', app.escCloseModal );

					if ( error.responseJSON.data && error.responseJSON.data.params && error.responseJSON.data.params.token ) {
						$( '.es-form-response-error .notice-title, .es-form-response-error .notice-2, .es-form-response-error .notice-default' ).removeClass( 'hidden' );
					} else if ( 'salesforce-submission-error' === error.responseJSON.code ) {
						$( '.es-form-response-error .notice-title, .es-form-response-error .notice-1, .es-form-response-error .notice-default' ).removeClass( 'hidden' );
					} else if ( 'age' === error.responseJSON.code ) {
						$( '.es-form-response-error .notice-title, .es-form-response-error .notice-3' ).removeClass( 'hidden' );
					} else {
						$( '.es-form-response-error .notice-title, .es-form-response-error .notice-default' ).removeClass( 'hidden' );
					}
				} );
			} );

		} );

	};

	/**
	 * Convert form array to name: value object.
	 *
	 * @since April 22, 2021
	 * @param {Array} data The form data.
	 * @return {Object} indexedArray The form data as a serialized JSON.
	 *
	 */
	app.createFormDataObject = function( data ) {
		const unindexedArray = data.serializeArray();
		const indexedArray = {};

		$.map( unindexedArray, function( n ) {
			if ( 'true' === n.value ) {
				n.value = true;
			}

			indexedArray[ n.name ] = n.value;
		} );

		// Remove the 'legal-accept' property
		delete indexedArray[ 'legal-accept' ];

		indexedArray[ 'language' ] = window.frontendi18n.lang;

		return indexedArray;
	};

	/**
	 * Determine if an Email Signup Form exists on the page.
	 *
	 * @since April 22, 2021
	 *
	 * @return {boolean} True if the requirements are met.
	 */
	app.meetsRequirements = function() {
		return app.$c.emailSignupForm.length;
	};

	// Engage!
	app.init();

}( window, jQuery, window.emailSignup ) );
